import React from 'react';
import AcronIQLoginForm from '../components/AcronIQLoginForm';
import styled from 'styled-components';

export default function LoginPage() {
  return (
    <LoginWrapper>
      <AcronIQLoginForm />
    </LoginWrapper>
  );
}

const LoginWrapper = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #2a2a2a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;
